import { FunctionComponent, useCallback } from 'react'
import { useStyles } from './styles'
import { useHistory } from 'react-router-dom'
import { Text } from '@conexasaude/conexa-hero'
import Modal from '@/components/Modal'
import { useModalContext } from '@/components/Modal/contexts/ModalContext'
import { Illustration } from '@/components/HideIllustrationsExternal'

const CancelledReservationModal: FunctionComponent = () => {
  const { closeModal } = useModalContext()
  const history = useHistory()

  const handleRecuseReservation = useCallback(() => {
    closeModal()
    history.push('/')
  }, [closeModal, history])
  const styles = useStyles()

  return (
    <Modal
      id="CANCELLED_RESERVATION"
      primaryAction={handleRecuseReservation}
      primaryActionLabel="Ok, entendi"
    >
      <div css={styles.modalWrapper}>
        <Text>Após a sua solicitação, recusamos o horário reservado.</Text>

        <Illustration name="medic-error" width="205px" height="205px" />
      </div>
    </Modal>
  )
}

export default CancelledReservationModal
